import request from "@utils/request";

export function verifyCard(data) {
  return request.post("/giftticket/subscribe", data, { login: false });
}

export function getGiftTicket(code) {
  return request.get("/giftticket/" + code, {}, { login: false });
}

export function postTakeGiftTicket(data) {
  return request.post("/addGiftticket/", data, { login: false });
}

export function getResult(code) {
  return request.get("/giftticket/getResult/" + code, {}, { login: false });
}

export function getConfig(code) {
  return request.get("/giftticket/getConfig/" + code, {}, { login: false });
}

export function getAnnouncement() {
  return request.get("/giftticket/getAnnouncement", {}, { login: false });
}
